import { ApiUtility, IApiResponse } from "../Utilities/ApiUtility.axios";

class SuperAdminLogService {
  route = `/Api/SuperAdminLog`;

 getAdminLogList = (
    start: number = 0,
    length: any = 15,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    fromDate?: string,
    toDate?: string,
    action?: number,
    subModule?: number,
    module?: number
    
  ): Promise<IApiResponse> =>
    ApiUtility.get(`${this.route}`, {
      start,
      length,
      search,
      sortCol,
      sortDir,
      fromDate,
      toDate,
      action,
      subModule,
      module
    });
}


export default new SuperAdminLogService();